/**
 * cn — helper para componer clases Tailwind.
 * Combina clsx (condicionales) + tailwind-merge (resuelve conflictos
 * como `p-2 p-4` → `p-4`, evita duplicados).
 *
 * Uso: <div className={cn('p-4', isActive && 'bg-primary-700', extraClass)} />
 *
 * IMPORTANTE: tailwind-merge se extiende con nuestros tamaños custom de
 * `fontSize` (display, h1..h4, body, caption, button) para que sepa que son
 * font-size y NO colisionen con `text-{color}`. Sin esta extensión, una clase
 * como `text-cream-50 text-button` se colapsaba a `text-button` y el botón
 * perdía su color → texto oscuro casi negro sobre fondo morado (ilegible).
 */
import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // Registra explícitamente nuestros font-size tokens de tailwind.config.ts
      // para que tailwind-merge no los confunda con text colors.
      'font-size': [
        { text: ['display', 'h1', 'h2', 'h3', 'h4', 'body', 'caption', 'button'] },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
